import { idmApi } from './http';

export async function getAllUsers() {
  const response = await idmApi.get('/users');
  return response.data.data;
}

export async function createNewUser(user) {
  const response = await idmApi.post('/users', { ...user });
  return response.data;
}

export async function updateUser(id, user) {
  const response = await idmApi.put(`/users/${id}`, { ...user });
  return response.data;
}
